import BaseAjaxService from '@adc/ajax/services/adc-ajax';

export default class Ajax extends BaseAjaxService {
    handleAjaxError(response, defaultMessage) {
        const errors = [{ detail: defaultMessage, message: response.errors }];

        return Promise.reject(errors);
    }
}
